export const ADD_STAFF_MEMBER = 1
export const EDIT_STAFF_MEMBER = 2
export const DELETE_STAFF_MEMBER = 3
export const DEACTIVATE_USER_ACCOUNT = 4
export const MANAGE_STAFF_MFA_SETTINGS = 5
export const FORCE_STAFF_PASSWORD_CHANGE = 6
export const VIEW_STAFF_SSO_LOGS = 7
export const REQUEST_SIPCENTRIC_ACCOUNT = 20
export const VIEW_STAFF_MEMBER_LIST = 75
export const EXPORT_STAFF_MEMBER_LIST = 76
